import { IconArrowDown } from './Down';
import { IconArrowLeft } from './Left';
import { IconArrowRight } from './Right';
import { IconArrowUp } from './Up';
import { IconArrowUpRight } from './UpRight';
export const IconArrow = {
    ArrowDown: IconArrowDown,
    ArrowLeft: IconArrowLeft,
    ArrowRight: IconArrowRight,
    ArrowUp: IconArrowUp,
    ArrowUpRight: IconArrowUpRight,
};
//# sourceMappingURL=index.js.map